<template>
  <div class="outBox">
    <el-tooltip
      class="item"
      effect="dark"
      :disabled="!trueTime"
      :content="displayTime"
      placement="top-start"
    >
      <el-select
        v-model="displayTime"
        :placeholder="placeholder"
        clearable=""
        @change="handleTime"
      >
        <el-option
          v-for="item in options"
          :key="item.value"
          :label="item.label"
          :value="item.value"
        >
        </el-option>
      </el-select>
    </el-tooltip>
    <el-date-picker
      ref="commonPicker"
      class="commonPicker"
      :popper-class="`${format === 'yyyy-MM-dd' ? 'no-hours' : ''}`"
      v-model="trueTime"
      type="datetimerange"
      range-separator="至"
      :format="format"
      :value-format="format"
      @change="setTime"
      @blur="hiddenPickerBox"
    />
  </div>
</template>
<script>
import { parseTime } from "@/utils";
export default {
  name: "datePicker",
  data() {
    return {
      displayTime: "",
      options: [
        {
          label: "最近24小时",
          value: "0",
        },
        {
          label: "最近7天",
          value: "1",
        },
        {
          label: "最近30天",
          value: "2",
        },
        {
          label: "自定义",
          value: "3",
        },
      ],
      trueTime: "",
      startTime: undefined,
      endTime: undefined,
      custom: false,
    };
  },
  props: {
    placeholder: {
      type: String,
      default: function () {
        return "请选择";
      },
    },
    format: {
      type: String,
      default: "yyyy-MM-dd HH:mm:ss",
    },
  },
  methods: {
    handleTime(value) {
      // console.log(value)
      if (value === "") {
        return this.clearTime();
      }
      let baseNums = -1;
      switch (value) {
        case "0":
          baseNums = 1;
          break;
        case "1":
          baseNums = 7;
          break;
        case "2":
          baseNums = 30;
          break;
        default:
          baseNums = -1;
          break;
      }
      if (baseNums > 0) {
        this.startTime = parseTime(
          new Date(new Date().getTime() - 3600 * 1000 * 24 * baseNums)
        );
        this.endTime = parseTime(new Date());
        this.trueTime = "";
        this.$emit("update:startTime", this.startTime);
        this.$emit("update:endTime", this.endTime);
        this.$emit("handleFilter");
      } else {
        // 切换为自定义状态
        this.custom = true;
        if (
          this.trueTime.indexOf(":") > -1 &&
          typeof this.trueTime === "string"
        ) {
          // 已自定义过时间
          this.displayTime = this.startTime + "至" + this.endTime;
        } else {
          this.displayTime = "自定义";
        }
        this.$refs.commonPicker.focus();
      }
    },
    clearTime() {
      this.displayTime = "";
      this.trueTime = "";
      this.startTime = undefined;
      this.endTime = undefined;
      this.$refs.commonPicker.blur();
      this.$emit("update:startTime", this.startTime);
      this.$emit("update:endTime", this.endTime);
      this.$emit("handleFilter");
      return false;
    },
    setTime(val) {
      // console.log(val)
      if (val) {
        this.displayTime = val[0] + "至" + val[1];
        this.startTime = val[0];
        this.endTime = val[1];
        this.trueTime = val[0] + "至" + val[1];
        this.$emit("update:startTime", this.startTime);
        this.$emit("update:endTime", this.endTime);
        this.$emit("handleFilter");
      } else {
        this.clearTime();
      }
    },
    hiddenPickerBox(el) {
      if (this.displayTime === "自定义") {
        this.clearTime();
      }
    },
  },
};
</script>
<style lang="scss">

.outBox {
  position: relative;
}
.commonPicker {
  visibility: hidden;
  position: absolute;
  left: 0;
  top: 0;
}
.longBox {
  width: 320px;
  .el-input,
  .el-input__inner {
    width: 100% !important;
  }
}
.no-hours {
  .el-date-range-picker__time-header {
    display: none;
  }
}
</style>
